// extracted by mini-css-extract-plugin
export var truncate = "_redotech-redo-web-src-wrap-truncate";